export const Programme = {
	management: function() {
		jQuery('body').undelegate('#modal-dialog', 'modal:loaded');

		jQuery('form').on('submit', function() {
			var url = $('#settings_fund_webpage').val();
			if(url.length > 0) {
				if(!url.includes('http') && !url.includes('://') ) {
					$('#settings_fund_webpage').val('http://' + url);
				}
			}
		});

		var onTopLevelChange = function() {
			var allLevels = jQuery('.result-chain-level-name');
			var hiddenLevels = jQuery('.result-chain-level-name[data-level="'+jQuery('#results_framework_config_first_level').val()+'"]').prevAll();

			// allLevels.find('input[type="text"]').removeAttr('disabled');
			allLevels.show();
			hiddenLevels.each(function() {
				// jQuery(this).find('input[type="text"]').attr('disabled', 'disabled');
				jQuery(this).hide();
			});
		};
		
		jQuery('body').delegate('#results_framework_config_first_level', 'change', onTopLevelChange);
		onTopLevelChange();

		jQuery('body').delegate('.result-chain-level-name input[type="text"]', 'change', function() {
			var newName = (jQuery('.result-chain-level-name input[type="text"]').index(this)+1) + '. ' + jQuery(this).val();
			jQuery('#results_framework_config_first_level option[value="'+jQuery(this).data('level')+'"]').text(newName);
		});


		$('.smartme-toggle').smartmeToggle();

		$('.modal-dialog').width(900);

		jQuery('.select2').select2();
	
    // Disabled: Would update only the registration‑text field, not the other locale sections.
    // Changes in the 'Available languages' component would require more complex handling here otherwise.
    // jQuery('#settings_available_languages').on('change', function(e) {
    //   if (e.removed) {
    //     jQuery('.registration-text-container-' + e.removed.id).remove();
    //   }

    //   if (e.added) {
    //     var locale = e.added.id;
    //     var title = jQuery('#settings_project_title').val();

    //     jQuery('.registration-texts-container').append(jQuery('#registration-text-template').html().
    //       replace(/__language__/g, locale).
    //       replace(/__label__/g, I18n.t('registration_text_for_language', { language: locale.toUpperCase() })).
    //       replace(/__registration_text__/g, I18n.t('register_for_funds_call', { fund: title, call: I18n.t('call_for_proposals', { locale: locale }), locale: locale })));
    //   }
    // });

		jQuery('#settings_time_of_daily_digest').flatpickr(
      {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
		allowInput: true
      });

	  jQuery('.open-datepicker').on('click', function () {
		jQuery(this).closest('.input-group').find('.flatpickr-input').trigger("focus");
	});
	},
	
	appearance: function() {

		jQuery('body').delegate('#modal-dialog', 'modal:loaded', function() {
			// init color pickers
			jQuery('.colorpicker-component').colorpicker();

			// update preview on color change
			jQuery('.colorpicker-component').on('changeColor', function(e) {
				var selector = jQuery(this).find('.color-picker-input').data('css-selector');
				var styles = jQuery('#color-scheme-edit-preview').text();
				styles = styles.replace(new RegExp(selector+'\\s*{(.+)}'),
					function(a){
						return a.replace(/\{.+\}/, function(r){
							return r.replace(/:\s*(#.{6}|rgba?\(.*\)|[a-zA-Z]+)/, ':' + e.color.toString('rgba'));
						});
				});
				jQuery('#color-scheme-edit-preview').text(styles);
			});
		});


		$('.smartme-toggle').smartmeToggle();

		$('.modal-dialog').width(900);


		if ($('#upload-logo').length > 0) {
			var dz = new Dropzone('#upload-logo', {
	            url: jQuery('#upload-logo').attr('action'),
	            headers: {"X-CSRF-Token": jQuery('meta[name="csrf-token"]').attr('content')},
	            maxFiles: 1,
	            acceptedFiles: 'image/*',
                addRemoveLinks: true,
                dictRemoveFile: '',
	            dictDefaultMessage: I18n.t('attachment_drop_instruction', {scope: 'fe'}),
	            dictInvalidFileType: I18n.t('file_must_be_image', {scope: 'fe'}),
	            init: function() {
	            	this.on('success', function(file, res){
	            		$('#settings_fund_logo_id').val(res.logo_id);
	            	});
	            }
	        });
		}
	},

	communication: function() {
			// Reload preview on change
			jQuery(".container-fluid").on('change', 'input, textarea, select', function(){
				ActionJS.Programme.render_preview(this);
			});

			jQuery(".container-fluid").on('click', '.language-selection li, .phase-selection li', function(){
				ActionJS.Programme.clear_preview(this);
			});

			// Resize iframe
			jQuery(".container-fluid .preview-iframe").on('load', function(){
				var margin = 18;
				this.height = this.contentWindow.document.querySelector('body').offsetHeight + margin + 'px';

				jQuery(this).closest('.email-template-preview').find('.loading-indicator').remove();
				jQuery(this).closest('.email-template-preview').find('.preview-iframe').removeClass('loading');
			});

			// View preview on click
			jQuery(".container-fluid").on('click', '.email-template-preview', function(){
				jQuery(this).append(SmartME.loadingIndicator(75));
				jQuery(this).find('.preview-iframe').addClass('loading');

				var selectedForm = jQuery(this).closest('.template-selection').find('.inner-tab.active');
				var outerTab = jQuery(this).closest('.template-selection').find('.outer-tab.active');
				var templateSelection = jQuery(this).closest('.template-selection').find('select');

				if (outerTab.length > 0){
					selectedForm = outerTab.find('.inner-tab.active');
					templateSelection = outerTab.find('select');
				}

				jQuery(this).find('iframe')[0].src = (jQuery(this).data('href').replace('__TEMPLATE_ID__', 
					templateSelection.val())) + '?' + selectedForm.find('input, textarea').serialize() + '&locale=' + selectedForm.data('locale');

				jQuery(this).find('span').addClass('hidden');
				jQuery(this).find('iframe').removeClass('hidden');
			});

	},

	communication_logs: function(){

    jQuery('body').on('click', function(e){
      if (jQuery(e.target).hasClass('status-info') || jQuery(e.target).hasClass('fa-question-circle')) {
        return;
      }
      jQuery('.status-info').tooltip('hide');
    });

    jQuery('body').on('click', '.status-info', function(){
      jQuery(this).tooltip('show');
    });

    jQuery('body').on('click', 'table#communication-log tbody tr', function(){
      jQuery(this).find('.extra').toggleClass('hidden');
    });


 		jQuery('table#communication-log').DataTable({
      serverSide: true,
      ajax: {
      	url: jQuery('table#communication-log').attr('data-href'),
	      type: 'post'
      },
			orderCellsTop: false,
      sorting: [[0, 'desc']],
      data: [],
      lengthMenu: [ [20, 50, 100, 200, 500], [20, 50, 100, 200, 500] ],
      dom: 'frtipl',
      searching: true,
      searchDelay: 1200,
      processing: true,
      pageLength: 20,
      language: {
        search: "_INPUT_",
        searchPlaceholder: I18n.t('search_by_email_or_title')
    	},
      columnDefs: [
      	{
      		width: '250px',
      		sortable: true,
      		targets: [0],
      		render: function(data, type, rowData){
            if(type == 'display') {

              var tooltip = Object.keys(data.reason).map(function(key, index){
                return jQuery('<div/>').append('<span>' + I18n.t(key, {scope: 'sendgrid_msg'}) + ': ' + data.reason[key] +'</span>').html();
              });
              return jQuery('#status-template')
                .html()
                .replace(/__status_label__/g, data.status_label)
                .replace(/__status__/g, data.status)
                .replace(/__timestamp__/g, data.timestamp)
                .replace(/__reason__/, tooltip.join(''))
                .replace(/__extra__/, function(){
                  return data.extra.map(function(value, index){
                    var content = "";
                    content += jQuery('<div/>').append('<span class="status-indicator ' + value.status + '"></span>').html();
                    content += jQuery('<div/>').append('<span class="status-text">' + I18n.t(value.status, {scope: 'sendgrid_msg'}) + '</span>').html();
                    content += jQuery('<div/>').append('<span class="status-timestamp">' + value.timestamp + '</span>').html();
                    return content + "";
                  }).join("")
                });
      			}
      			return data.status;
      		}
      	},
      	{
      		sortable: false,
      		targets: [1],
      		render: function(data, type, rowData){
      			if(type == 'display') {
              return jQuery('#message-template')
                .html()
                .replace(/__email__/g, data.email)
                .replace(/__title__/g, data.title);
            }
            return data.email;
      		}
      	},
      	{
          sortable: false,
          width: '250px',
      		targets: [2],
      		render: function(data, type, rowData){
      			if(type == 'display') {
              return jQuery('#event-template')
                .html()
                .replace(/__opens__/g, data.opens)
								.replace(/__clicks__/g, data.clicks)
                .replace(/__extra__/, function(){
                  return data.extra.map(function(value, index){
                    var content = "";
                    content += jQuery('<div/>').append('<span class="status-text ' + value.status +' ">' + I18n.t(value.status, {scope: 'sendgrid_msg'}) + '</span>').html();
                    content += jQuery('<div/>').append('<span class="status-timestamp">' + value.timestamp + '</span>').html();
                    return content;
                  }).join("")
                });
            }
            return data.opens;
      		}

				},
				{
          sortable: false,
          width: '100px',
					targets: [3],
      		render: function(data, type, rowData){
      			if(type == 'display') {
              return jQuery('#email-preview-template')
                .html()
								.replace(/__template_id__/g, data.template_id)
								.replace(/__message_id__/g, data.message_id);
            }
            return null;
      		}
      	},
      ],
      drawCallback: function() {
        DataTablesHelper.addColumnFilters(this);
      	jQuery('[data-tooltip="true"]').tooltip({placement:'right', html: 'true', trigger: 'manual'});
      },
      footerCallback: function () {
        DataTablesHelper.togglePagination(this);
      },
      initComplete: function() {
        jQuery('#communication-log_filter').appendTo('thead tr .search');
      }
  	});

	},

	clear_preview: function(selector) {
		jQuery(selector).closest('.template-selection').find('.preview-iframe').addClass('hidden');
		jQuery(selector).closest('.template-selection').find('iframe')[0].src = ''
		jQuery(selector).closest('.template-selection').find('.email-template-preview span').removeClass('hidden');
	},

	render_preview: function(selector){
		var $preview = jQuery(selector).closest('.template-selection').find('.email-template-preview');
		$preview.append(SmartME.loadingIndicator(75));

		var selectedForm = jQuery(selector).closest('.tab-content').find('.inner-tab.active');

		jQuery($preview).find('iframe')[0].src = (jQuery($preview).data('href').replace('__TEMPLATE_ID__', 
			jQuery(selector).closest('.tab-content').find('select').val())) + '?' + selectedForm.find('input, textarea').serialize() + '&locale=' + selectedForm.data('locale');
		jQuery($preview).find('span').addClass('hidden');
		jQuery($preview).find('iframe').removeClass('hidden');
	},

	note_selection: function() {

		// Delete options that are already in use.
		var inUse = jQuery('#note-submitted').find('.phase-selection li a').map(function(){ return jQuery(this).data('id') }).get();
		inUse.forEach(function(id){
			jQuery('#note-selection option[value="' + id + '"]').remove();
		});

		jQuery('#note-selection').on('submit', function(){
			var identifier = jQuery(this).find('select').val();
			var label = jQuery(this).find('option:selected').text();

			var navtab = jQuery('#nav-tab-template').html();
			navtab = navtab.replace('__nav-tab-name__', label).replace(/__tab-pane-id__/g, identifier);
			var tabpane = jQuery('#tab-pane-template').html().replace().replace(/__tab-pane-id__/g, identifier);

			var container = jQuery('#note-submitted');

			container.find('.phase-selection li:last-child').before(navtab);
			container.append(tabpane);

			jQuery('.modal').modal('hide');

			return false;
		});

	},

	management_save: function() {
		this.management();
	},

	management_invite: function() {
		$(".smartme-toggle").smartmeToggle();
		jQuery('#modal-dialog .select2').select2();

		var toggleEmailConfirmed = function() {
			var loginMethod = jQuery("select#invitation_login_method");

			if (loginMethod.val() == "saml") {
        loginMethod.closest("form").find("#confirmed-email").closest(".form-group").hide();
      } else {
        loginMethod.closest("form").find("#confirmed-email").closest(".form-group").show();
      }
		}

		toggleEmailConfirmed();

		jQuery("select#invitation_login_method").on('change', toggleEmailConfirmed);
	},

	project_details: function() {

        jQuery('a.delete-fact-sheet').on('click', function() {
            var a = jQuery(this);

            if (confirm(a.attr('data-confirm'))) {
                SmartME.setLoadingIndicator('.main', {overlay: true});
                jQuery.ajax({
                    url: a.attr('href'),
                    type: 'DELETE',
                    success: function() {
                        Turbo.visit(window.location);
                    }
                });
            }
            return false;
        });
	},

	_manage_project_details_setting: function() {
		$('.smartme-toggle').smartmeToggle();
	},

	_manage_project_api_access: function() {
		// get the page length when first load
		var initWindowHeight = jQuery(window).height();
		var initItemsPerPage = getPageLength(initWindowHeight);

		var table = jQuery('table.api-access').DataTable({
				data: JSON.parse(jQuery('#api-access-data').html()),
				info: false,
				lengthChange: false,
				language: {
						searchPlaceholder: I18n.t('search')
				},
				pageLength: initItemsPerPage, 
				autoWidth: false,
				columnDefs: [
						{
							targets: 0,
							render: function (data, type, row, meta) {
									if (type == 'display') {
											return jQuery('#api-identifier-template').html().
													replace(/__id__/g, encodeURIComponent(data.id)).
													replace(/__label__/g, data.name).
													replace(/__title__/g, data.name);
									}
									return data.name;
							},
						},
						{ 
							targets: 2,
							className: 'truncate-10-char' 
						},
						{
							targets: 3,
							className: 'overflow-wrap'
						},
						{
								orderable: false,
								render: function(data, type, row, meta) {
										if (type == 'display') {
												return jQuery('#api-access-actions-template').html().
														replace(/__id__/g, data.id);
										}
										return '';
								},
								targets: 4
						}
				],
				footerCallback: function () {
						DataTablesHelper.togglePagination(this);
				}
		});

		table.on('click', 'a.delete-api-key', function() {
				var a = jQuery(this);

				if (confirm(a.attr('data-confirm'))) {
						jQuery.post(a.attr('href'), function() {
								Turbo.visit(window.location.href);
						});
						a.hide();
				}
				return false;
		});
		var resizeId;
		// get the length after user stop resizing for 500ms
		jQuery(window).resize(function(){
				clearTimeout(resizeId);
				resizeId = setTimeout(resizeList, 500);
		})
		function resizeList(){
				var windowHeight = jQuery(window).height();
				var itemsPerPage = getPageLength(windowHeight);
				if (itemsPerPage!=table.page.len()){
						table.page.len(parseInt(itemsPerPage)).draw();
				}
		}
		function getPageLength(height) {
				switch(true){
						case height>1100:
								return 20;
						case height>800:
								return 15;
						case height>600:
								return 10;
						default:
								return 5;
				}
		}
	},

	_auth_identity_field: function() {
		var onDefaultAuthIdentityChange = function () {
			var selection = jQuery('#default_auth_identity');
			var map = selection.data('desc-map') || {};
			var desc = map[selection.val()] || '';
			jQuery('#default_auth_identity_description').text(desc);
		};
		jQuery(document).on('change', '#default_auth_identity', onDefaultAuthIdentityChange);
	},
};



export const ProgrammeIndicatorUnit = {

	list: function() {
		jQuery('.common-units').on('click', '.unit-check', function() {
			jQuery.post(this.getAttribute('data-url'), {
				selected: jQuery(this).prop('checked')
			});
		});

		jQuery('.custom-units').on('click', 'a.delete-unit', function() {
			var a = jQuery(this);

			if (confirm(a.attr('data-confirm'))) {
				jQuery.post(a.attr('href'), function() {
					Turbo.visit(window.location.href);
				});
				a.hide();
			}
			return false;
		});
	}
};
